// Thin axios wrappers for the Ekonomika / Horowitzova banka API. Matches the
// rest of the codebase's convention (axios + useState/useEffect) rather than
// react-query, which is a listed dependency but has no real usage anywhere
// else in this app.

import axios from "axios";

export const listCompanies = (includeDeleted = false) =>
  axios.get("/api/economy/companies", { params: { include_deleted: includeDeleted } }).then((r) => r.data);

export const getCompany = (id) => axios.get(`/api/economy/companies/${id}`).then((r) => r.data);

export const createCompany = (payload) => axios.post("/api/economy/companies", payload).then((r) => r.data);

export const updateCompany = (id, payload) => axios.patch(`/api/economy/companies/${id}`, payload).then((r) => r.data);

export const activateCompany = (id) => axios.post(`/api/economy/companies/${id}/activate`).then((r) => r.data);

export const deactivateCompany = (id) => axios.post(`/api/economy/companies/${id}/deactivate`).then((r) => r.data);

export const deleteCompany = (id) => axios.delete(`/api/economy/companies/${id}`).then((r) => r.data);

export const grantShares = (id, payload) => axios.post(`/api/economy/companies/${id}/shares/grant`, payload).then((r) => r.data);

export const revokeShares = (id, payload) => axios.post(`/api/economy/companies/${id}/shares/revoke`, payload).then((r) => r.data);

export const transferShares = (id, payload) => axios.post(`/api/economy/companies/${id}/shares/transfer`, payload).then((r) => r.data);

export const searchCharacters = (q) => axios.get("/api/economy/characters/search", { params: { q } }).then((r) => r.data);

export const getMyInvestments = () => axios.get("/api/economy/me/investments").then((r) => r.data);

export const getMyWallets = () => axios.get("/api/economy/me/wallets").then((r) => r.data);

export const getEconomyStatus = () => axios.get("/api/economy/status").then((r) => r.data);

export const getMarketplace = () => axios.get("/api/economy/marketplace").then((r) => r.data);

export const buyShares = (id, payload) => axios.post(`/api/economy/companies/${id}/shares/buy`, payload).then((r) => r.data);

export const uploadCompanyImage = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post("/api/economy/uploads/company-image", formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export const getMarketHistory = (id) => axios.get(`/api/economy/companies/${id}/market-history`).then((r) => r.data);

export const adjustMarket = (id, payload) => axios.post(`/api/economy/companies/${id}/market/adjust`, payload).then((r) => r.data);

export const depositToBank = (characterGuid, amount) =>
  axios.post(`/api/economy/characters/${characterGuid}/wallet/deposit`, { amount }).then((r) => r.data);

export const withdrawFromBank = (characterGuid, amount) =>
  axios.post(`/api/economy/characters/${characterGuid}/wallet/withdraw`, { amount }).then((r) => r.data);
